export default "__VITE_ASSET__DpIyP89e__"